// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + chunkId + "-legacy." + {"143":"23e0ad52","318":"2fd845a5","538":"43a997e8","823":"fa91aac2"}[chunkId] + ".js"; };